export default __webpack_public_path__ + "static/media/twitter_logo.eefa8c91.svg";